import { useAction, useAtom } from "@reatom/npm-react";
import { useEffect, useMemo, useState } from "react";
import { useMatch } from "react-router-dom";

import { ARTICLE_ROUTE } from "./constants";
import { knowledgePage, knowledgeTree } from "./store";
import { IKBSection } from "./types";
import { getKBTocItems, hasKBArticle } from "./utils";

export const useKnowledgeBaseLayout = (basePath: string) => {
  const [activeId, setActiveId] = useState<string | null>(null);
  const loadTree = useAction(knowledgeTree);

  const [treeData] = useAtom(knowledgeTree.dataAtom);
  const [pageData] = useAtom(knowledgePage.dataAtom);

  const tree: IKBSection[] | undefined = treeData?.tree;
  const articleMatch = useMatch(`${basePath}/${ARTICLE_ROUTE}`);

  const { sectionSlug = "", docSlug = "" } = articleMatch?.params ?? {};
  const isArticleShown =
    tree !== undefined &&
    hasKBArticle(tree, sectionSlug, docSlug) &&
    pageData?.slug === docSlug;

  const articleContent = isArticleShown ? pageData?.content ?? "" : "";

  const itemsToc = useMemo(
    () => getKBTocItems(articleContent),
    [articleContent],
  );

  useEffect(() => {
    if (!tree) loadTree();
  }, [tree, loadTree]);

  return {
    tree,
    itemsToc,
    activeId: isArticleShown ? activeId : null,
    setActiveId,
    activeSectionSlug: sectionSlug,
  };
};
